/** @format */

import {Box} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import {type StatusDataInterface} from 'pages/HomeGrouping/types';

import {StatusBadge} from './StatusBadge';
import {StatusRowRoot, SensorPill, CounterChip, CriticalChip, NoMediaplanChip} from './styles';

interface Props {
  statuses: StatusDataInterface[];
  triggered: number;
  critical: number | null;
  hasMediaplan: boolean;
}

const StatusRow = ({statuses, triggered, critical, hasMediaplan}: Props) => {
  const {t} = useTranslation();

  return (
    <StatusRowRoot>
      {statuses.map(status => (
        <StatusBadge key={status.title} data={status} />
      ))}

      <SensorPill>
        <CounterChip>
          <Box
            component='span'
            className='material-symbols-outlined'
            sx={{'&.material-symbols-outlined': {fontSize: '16px', lineHeight: '16px'}}}
          >
            sensors
          </Box>
          {t('Срабатываний сенсоров: {{count}}', {count: triggered})}
        </CounterChip>

        {critical !== null && critical > 0 && (
          <CriticalChip>{t('Критичных: {{count}}', {count: critical})}</CriticalChip>
        )}
      </SensorPill>

      {!hasMediaplan && (
        <NoMediaplanChip>
          <Trans>Нет медиаплана</Trans>
        </NoMediaplanChip>
      )}
    </StatusRowRoot>
  );
};

export {StatusRow};
